/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ target: NonNullable<unknown> }} Workout_Of_TargetInputs */

const en_us2_workout_of_target = /** @type {(inputs: Workout_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`of ${i?.target}`)
};

const pt_br2_workout_of_target = /** @type {(inputs: Workout_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.target}`)
};

const es_419_workout_of_target = /** @type {(inputs: Workout_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.target}`)
};

const pt_pt2_workout_of_target = /** @type {(inputs: Workout_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`de ${i?.target}`)
};

const fr_fr2_workout_of_target = /** @type {(inputs: Workout_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`sur ${i?.target}`)
};

const de_de2_workout_of_target = /** @type {(inputs: Workout_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`von ${i?.target}`)
};

const it_it2_workout_of_target = /** @type {(inputs: Workout_Of_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`di ${i?.target}`)
};

/**
* | output |
* | --- |
* | "of {target}" |
*
* @param {Workout_Of_TargetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_of_target = /** @type {((inputs: Workout_Of_TargetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Of_TargetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_of_target(inputs)
	if (locale === "es-419") return es_419_workout_of_target(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_of_target(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_of_target(inputs)
	if (locale === "de-DE") return de_de2_workout_of_target(inputs)
	if (locale === "it-IT") return it_it2_workout_of_target(inputs)
	return en_us2_workout_of_target(inputs)
});
export { workout_of_target as "workout.of_target" }